export default "__VITE_ASSET__4c82acf0__"